import { theme } from '@garnish/constants';

// ─── Location Results ────────────────────────────────────────────────────────

export const LOCATION_RESULTS_THEME_BG_COLOR = theme.colors.OATMEAL;
export const LOCATION_RESULTS_BORDER_RADIUS = 12;
export const LOCATION_RESULTS_OTHER_LOCATIONS_TITLE_HEIGHT = 54;
export const LOCATION_RESULTS_TOGGLE_BTN_HEIGHT = 40;
export const LOCATION_RESULTS_CARD_HEIGHT = 112;
export const LOCATION_RESULTS_CARD_HEIGHT_PADDING_VERTICAL = 12;
export const LOCATION_RESULTS_CARD_HEIGHT_WITHOUT_PADDING =
  LOCATION_RESULTS_CARD_HEIGHT -
  LOCATION_RESULTS_CARD_HEIGHT_PADDING_VERTICAL * 2;

export const LOCATION_RESULTS_COLLAPSED_HEIGHT_SINGLE_RESULT =
  LOCATION_RESULTS_CARD_HEIGHT;
export const LOCATION_RESULTS_COLLAPSED_HEIGHT_MULTIPLE_RESULTS =
  LOCATION_RESULTS_CARD_HEIGHT + LOCATION_RESULTS_TOGGLE_BTN_HEIGHT;

// ─── Location Results Card ───────────────────────────────────────────────────

export const LOCATION_RESULTS_CARD_IMG_SIZE = 88;
export const LOCATION_CARD_IMG_CLOUDINARY_CONFIG = {
  width: LOCATION_RESULTS_CARD_IMG_SIZE,
  height: LOCATION_RESULTS_CARD_IMG_SIZE,
  crop: 'fill',
} as const;
export const LOCATION_CARD_IMG_BG_COLOR = theme.colors.OPACITY.KHAKI_2.DARKER;
